import React, { useState, Fragment } from "react";
import _ from "lodash";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import IconButton from "@mui/material/IconButton";

import PencilOutline from "mdi-material-ui/PencilOutline";
import DeleteOutline from "mdi-material-ui/DeleteOutline";

import QuickSearchToolbar from "views/components/QuickSearchToolbar";
import DialogModal from "@core/components/dialogmodal";
import { isPermissionAllow } from "@core/utils/IsPermissionAllow";

const LibraryCategoryList = (props) => {
  const [deleteId, setDeleteId] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);

  const {
    handleDeleteModal,
    deleteOpen,
    handleOpen,
    libraryCateList,
    pageSize,
    searchText,
    pageNumber,
    setPageSize,
    setSearchText,
    setPageNumber,
    totalRecord,
    permission,
    role,
  } = props;

  const handleEdit = (id) => {
    handleOpen("edit", id);
  };

  const handleDelete = (id) => {
    handleDeleteModal();
    setDeleteId(id);
  };

  const columns = [
    {
      flex: 0.4,
      minWidth: 80,
      field: "index",
      headerName: "Index",
    },
    {
      flex: 3,
      minWidth: 150,
      field: "cat_name",
      headerName: "category",
    },
    {
      flex: 3,
      minWidth: 150,
      field: "total_books",
      headerName: "Total Books",
    },
    {
      flex: 1,
      minWidth: 100,
      field: "action",
      headerName: "Actions",
      renderCell: ({ row }) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              {((permission.edit && role === "2") || role === "1") && (
                <IconButton onClick={() => handleEdit(row.id)}>
                  <PencilOutline fontSize="medium" />
                </IconButton>
              )}
              {((permission.delete && role === "2") || role === "1") && (
                <IconButton onClick={() => handleDelete(row.id)}>
                  <DeleteOutline fontSize="medium" />
                </IconButton>
              )}
            </Box>
          </Box>
        );
      },
    },
  ];
  const removeaction =
    !permission.edit && !permission.delete && role === "2"
      ? _.dropRight(columns)
      : columns;

  const handleSearch = (searchValue) => {
    setSearchText(searchValue);
  };

  const assemList = libraryCateList.map((data, index) => {
    return {
      index: index + pageSize * pageNumber + 1,
      id: data.id,
      cat_name: data.cat_name,
      total_books: data.total_books,
    };
  });

  return (
    <Fragment>
      <Card sx={{ width: "100%", overflowInline: "hidden" }}>
        <DataGrid
          hideFooterSelectedRowCount
          autoHeight
          localeText={{ noRowsLabel: "No results found" }}
          columns={removeaction}
          rows={assemList}
          pageSize={pageSize}
          rowCount={Number(totalRecord)}
          checkboxSelection={isPermissionAllow(permission.delete, role)}
          disableSelectionOnClick
          components={{
            Toolbar: QuickSearchToolbar,
          }}
          page={pageNumber}
          onPageChange={(newPageNumber) => {
            setPageNumber(newPageNumber);
          }}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          onSelectionModelChange={(rows) => setSelectedRows(rows)}
          componentsProps={{
            toolbar: {
              value: searchText,
              clearSearch: () => handleSearch(""),
              onChange: (event) => handleSearch(event.target.value),
              handleOpen: () => handleOpen("add", ""),
              title: isPermissionAllow(permission.edit, role)
                ? "Add Library Category"
                : "",
              selectedRows: selectedRows,
              onClickDelete: () => handleDeleteModal(),
              multiDelete: isPermissionAllow(permission.delete, role),
            },
          }}
          sx={{
            ".MuiTablePagination-displayedRows": {
              marginTop: "1rem",
            },
            ".MuiTablePagination-selectLabel": {
              marginTop: "1.1rem",
            },
            ".MuiInputBase-root": {
              marginTop: "0.2rem",
            },
          }}
          rowsPerPageOptions={[10, 25, 50]}
          pagination
          paginationMode="server"
        />
      </Card>

      {deleteOpen && (
        <DialogModal
          open={deleteOpen}
          handleClose={() => handleDeleteModal()}
          handleDelete={() =>
            handleDeleteModal(
              selectedRows && selectedRows.length === 0
                ? [deleteId]
                : selectedRows
            )
          }
        />
      )}
    </Fragment>
  );
};

export default LibraryCategoryList;
